import { IBlock } from "../../../framework/src/IBlock";
import { Message } from "../../../framework/src/Message";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import MessageEnum, {
  getName
} from "../../../framework/src/Messages/MessageEnum";
import { runEngine } from "../../../framework/src/RunEngine";

// Customizable Area Start
// Customizable Area End

export const configJSON = require("./config");

export interface Props {
  navigation: any;
  id: string;
  // Customizable Area Start
  footerData: any;
  // Customizable Area End
}

interface S {
  // Customizable Area Start
  privacyPolicyContent: string;
  termsConditionsContent: string;
  emailAddress: string,
  phoneNumber: string,
  countryCodeSelected: string,
  callingCode: string,
  // Customizable Area End
}

interface SS {
  id: any;
  navigation: any;
}

export default class FooterController extends BlockComponent<
  Props,
  S,
  SS
> {

  handlePrivacyPolicyApiCallId: string = "";
  handleTermsConditionsApiCallId: string = "";
  constructor(props: Props) {
    super(props);
    this.receive = this.receive.bind(this);

    // Customizable Area Start
    this.subScribedMessages = [
      getName(MessageEnum.RestAPIResponceMessage),
      getName(MessageEnum.NavigationPayLoadMessage),
      getName(MessageEnum.CountryCodeMessage),
      getName(MessageEnum.RestAPIRequestMessage),
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      getName(MessageEnum.RestAPIRequestMethodMessage),
      getName(MessageEnum.RestAPIResponceErrorMessage),
      getName(MessageEnum.RestAPIResponceDataMessage),
      getName(MessageEnum.RestAPIResponceSuccessMessage),
    ];

    this.state = {
      privacyPolicyContent: "",
      termsConditionsContent: "",
      emailAddress: "",
      phoneNumber: "",
      countryCodeSelected: "DE",
      callingCode: "49",
    };
    // Customizable Area End
    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);
  }


  async receive(from: string, message: Message) {
    // Customizable Area Start
    if (getName(MessageEnum.RestAPIResponceMessage) === message.id) {
      const apiRequestCallId = message.getData(
        getName(MessageEnum.RestAPIResponceDataMessage)
      );
  
      const responseJson = message.getData(
        getName(MessageEnum.RestAPIResponceSuccessMessage)
      );  
    
    if (apiRequestCallId === this.handlePrivacyPolicyApiCallId){
      this.handlePrivacyPolicyResponse(responseJson); 
    }
    if (apiRequestCallId === this.handleTermsConditionsApiCallId){
      this.handleTermsConditionsResponse(responseJson); 
    }
    }
    // Customizable Area End
  }

  // Customizable Area Start

  handlePrivacyPolicyResponse (responseJson: any){
    if (responseJson?.data){
      this.setState({privacyPolicyContent: responseJson.data[0].description});

      const payloadData = { privacyPolicyContent: this.state.privacyPolicyContent, showProfile: true, emailAddress: this.state.emailAddress, phoneNumber: this.state.phoneNumber, countryCodeSelected: this.state.countryCodeSelected, callingCode: this.state.callingCode}
          const msgNavigation = new Message(getName(MessageEnum.NavigationMessage));
          msgNavigation.addData(getName(MessageEnum.NavigationTargetMessage), "TermsConditionsDetail");
          msgNavigation.addData(getName(MessageEnum.NavigationPropsMessage), this.props);
          const raiseMessage: Message = new Message(getName(MessageEnum.NavigationPayLoadMessage));
          raiseMessage.addData(getName(MessageEnum.NavigationPayLoadMessage), payloadData);
          msgNavigation.addData(getName(MessageEnum.NavigationRaiseMessage), raiseMessage);
          this.send(msgNavigation);

    }     
  }

  handleTermsConditionsResponse (responseJson: any){
    if (responseJson?.data){

      this.setState({termsConditionsContent: responseJson.data[0].description});

          const payloadData = { termsConditionsContent: this.state.termsConditionsContent, showProfile: true, emailAddress: this.state.emailAddress, phoneNumber: this.state.phoneNumber, countryCodeSelected: this.state.countryCodeSelected, callingCode: this.state.callingCode}
          const msgNavigation = new Message(getName(MessageEnum.NavigationMessage));
          msgNavigation.addData(getName(MessageEnum.NavigationTargetMessage), "TermsConditionsUsers");
          msgNavigation.addData(getName(MessageEnum.NavigationPropsMessage), this.props);
          const raiseMessage: Message = new Message(getName(MessageEnum.NavigationPayLoadMessage));
          raiseMessage.addData(getName(MessageEnum.NavigationPayLoadMessage), payloadData);
          msgNavigation.addData(getName(MessageEnum.NavigationRaiseMessage), raiseMessage);
          this.send(msgNavigation);

    }    
  }
  gobackHome() {
    const msg: Message = new Message(
      getName(MessageEnum.NavigationHomeScreenMessage)
    );
    msg.addData(getName(MessageEnum.NavigationPropsMessage), this.props);
    this.send(msg);
  }

  scrollToHome = () => {
    const homeSection = document.getElementById("home-section");
      if (homeSection) {
        homeSection.scrollIntoView({ behavior: "smooth" });
      }
  }

  scrollToConnect = () => {
    const connectSection = document.getElementById("connect-section");
      if (connectSection) {
        connectSection.scrollIntoView({ behavior: "smooth" });
      }
  }

  scrollToPitch = () => {
    const pitchSection = document.getElementById("pitch-section");
      if (pitchSection) {
        pitchSection.scrollIntoView({ behavior: "smooth" });
      }
  }

  handlePrivacyPolicyClick = () => {
    this.getPrivacyPolicy();
  }

  handleTermsConditionsClick = () => {
    this.getTermsConditions();
  }

  getPrivacyPolicy = async () => {
    const headers = {
      "Content-Type": configJSON.validationApiContentType
    };
  
    const handlePrivacyPolicyMsg = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );
    this.handlePrivacyPolicyApiCallId = handlePrivacyPolicyMsg.messageId;
  
    handlePrivacyPolicyMsg.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.urlGetPrivacyPolicy
    );
  
    handlePrivacyPolicyMsg.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(headers)
    );
  
    handlePrivacyPolicyMsg.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.validationApiMethodType
    );
  
    runEngine.sendMessage(handlePrivacyPolicyMsg.id, handlePrivacyPolicyMsg);
  };

  getTermsConditions = async () => {
    const headers = {
      "Content-Type": configJSON.validationApiContentType
    };
  
    const handleTermsConditionsMsg = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );
    this.handleTermsConditionsApiCallId = handleTermsConditionsMsg.messageId;
  
    handleTermsConditionsMsg.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.urlGetTermsConditions
    );
  
    handleTermsConditionsMsg.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(headers)
    );
  
    handleTermsConditionsMsg.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.validationApiMethodType
    );
  
    runEngine.sendMessage(handleTermsConditionsMsg.id, handleTermsConditionsMsg);
  };

  // Customizable Area End
}
